import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-new',
  templateUrl: './dashboard-new.component.html',
  styleUrls: ['./dashboard-new.component.scss']
})
export class DashboardNewComponent implements OnInit {

  selectMenu=1;
  
  constructor() { }

  ngOnInit() {
  }

}
